import script from "./cClipboard.vue?vue&type=script&lang=js"
export * from "./cClipboard.vue?vue&type=script&lang=js"

import "./cClipboard.vue?vue&type=style&index=0&id=395de6b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-395de6b4"],['__file',"src/components/cmp/cClipboard/cClipboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "395de6b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('395de6b4', __exports__)) {
    api.reload('395de6b4', __exports__)
  }
  
}


export default __exports__